/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE.
*/

"use client";

import { isError } from "@epic-mw/error-types";
import useSWRImmutable from "swr/immutable";

import { useAccountId } from "../account/account.hooks";
import { getApiPath } from "../utils";

export interface AodcPolicyRes {
	AODCFailed: boolean;
}

const getAODCPolicy = async (): Promise<AodcPolicyRes> => {
	try {
		const response = await fetch(`${getApiPath()}/policy/aodc`);
		const json = await response.json();
		return {
			AODCFailed: json.failed,
		};
	} catch (err) {
		console.error("getAODCPolicy() failed to load", isError(err) && err.message);
		throw err;
	}
};

interface HookRes {
	result: AodcPolicyRes | undefined;
	isLoading: boolean;
	error: any;
}

export const useAccountAODCPolicy = (): HookRes => {
	const accountId = useAccountId();
	const shouldFetch = Boolean(accountId);

	const { data, error } = useSWRImmutable(shouldFetch ? `aodc-${accountId}` : null, getAODCPolicy, {
		errorRetryCount: 0,
	});

	return {
		result: data,
		isLoading: Boolean(!data && !error && shouldFetch),
		error,
	};
};
